import * as React from 'react';
import { ProfilMenuItem } from '../../profilMenuItem';
import { useAuthState } from 'react-firebase-hooks/auth';
import { auth, db } from '../../../config/firebase';
import { useEffect, useContext } from 'react';
import '../../../assets/css/homepage.css';
import { Box, IconButton, Menu, Button } from '@mui/material';
import MenuRoundedIcon from '@mui/icons-material/MenuRounded';
import Toolbar from '@mui/material/Toolbar';
import { AppBar, Container, Grid, Link } from '@mui/material/node';
import { AuthContext } from '../../../contexts/authContext';
import { collection, getDocs, query, where } from 'firebase/firestore';
import { useQuery } from '@tanstack/react-query';
import HubIcon from '@mui/icons-material/Hub';

const pages = ['Products', 'Pricing', 'Blog'];

export const MyAppBar = () => {
  const { user, loading } = useContext(AuthContext);
  // const [user, loading, error] = useAuthState(auth);
  //const [userProfile, setUserProfile] = React.useState(<a className="smoothscroll" href="/login">Logn in / Sign up</a>);
  const [userProfile, setUserProfile] = React.useState(<Button variant="contained" color="primary" style={{ borderRadius: 20}}>Sign in</Button>);
  const [anchorElNav, setAnchorElNav] = React.useState(null);
  const [anchorElUser, setAnchorElUser] = React.useState(null);

  const { data: uData, isDataLoading, isDataError } = useQuery({
    queryKey: ["loadprofile"], queryFn: async () => {
      const q = query(collection(db, "user"), where("owner", "==", user.uid));
      const data = await getDocs(q)

      const filteredData = data.docs.map((doc) => ({
        email: user.email,
        uid: user.uid,
        ...doc.data(),
      }));

      if (filteredData.length !== 1) {
        console.log("ERROR");
      }

      return filteredData[0];
    }
  });

  useEffect(() => {
    if (loading) return;
    if (user) {
      setUserProfile(<ProfilMenuItem userData={uData} />);
    }
  }, [user, loading, uData]);




  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  return (
    <>
      <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}>
        <AppBar position="static" elevation={0} sx={{ bgcolor: "rgb(252, 251, 251)" }}>
          <Toolbar>
            <IconButton
              size="large"
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleOpenNavMenu}
            >
              <MenuRoundedIcon />
            </IconButton>
            <Menu
              id="menu-appbar"
              anchorEl={anchorElNav}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
              }}
              open={Boolean(anchorElNav)}
              onClose={handleCloseNavMenu}
              sx={{
                display: { xs: 'block', md: 'none' },
              }}
            >
              <ul id="nav" className="navMob">
                <li>
                  <a className="smoothscroll" href="/#home">
                    Home
                  </a>
                </li>
                <li>
                  <a className="smoothscroll" href="/#features">
                    Features
                  </a>
                </li>

                <li>
                  <a className="smoothscroll" href="/#publicprojects">
                    Public Projects
                  </a>
                </li>

                <li>
                  <a href="/#contactus">
                    Contact Us
                  </a>
                </li>
              </ul>
            </Menu>

            {userProfile}
          </Toolbar>
        </AppBar>
      </Box>
        <Grid container className="container flexSpaceCenter nav">
          <Grid size={1}>
            <Link className="pointer flexNullCenter" to="home" smooth={true}>
              <HubIcon />
              <h1 style={{ marginLeft: "15px" }} className="font20 extraBold">
                NodeCanvas
              </h1>
            </Link>
          </Grid>
          <Grid size={9}>
            <ul className="flexNullCenter">
              <li className="semiBold font15 flexNullCenter pointer">
                {/* <a className="smoothscroll" href="/#home"> */}
                <Link style={{ padding: "10px 15px" }}>
                  Home
                </Link>
              </li>
              <li></li>
              <li className="semiBold font15 pointer">
                {/* <a className="smoothscroll" href="/#home"> */}
                <Link style={{ padding: "10px 15px" }}>
                  Home
                </Link>
              </li>

              <li className="semiBold font15 pointer">
                {/* <a className="smoothscroll" href="/#features"> */}
                <Link style={{ padding: "10px 15px" }}>
                  Features
                </Link>
              </li>

              <li className="semiBold font15 pointer">
                {/* <a className="smoothscroll" href="/#publicprojects"> */}
                <Link style={{ padding: "10px 15px" }}>
                  Public Projects
                </Link>
              </li>

              <li className="semiBold font15 pointer">
                <Link style={{ padding: "10px 15px" }}>
                  Contact Us
                </Link>
              </li>
            </ul>
          </Grid>
          <Grid size={2}>
            <ul id="nav" className="flexNullCenter">
              <li>
                {userProfile}
              </li>
            </ul>
          </Grid>
        </Grid>
    </>
  );
}